/**
 * Verti DEU PL API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * * `Regular`     - german: regulärer Preis * `Reference`   - german: Streichpreis * `Additional`  - german: zusätzliche Preisberechnung
 */
export const PriceCalculationKind = {
  Regular: 'Regular',
  Reference: 'Reference',
  Additional: 'Additional',
} as const;
export type PriceCalculationKind = (typeof PriceCalculationKind)[keyof typeof PriceCalculationKind];
